<template>
    <div class="tabs flex">
        <div v-for="item in list" :key="item.code" 
        :class="currentTab==item.code?'active':''"
        @click="dealTabs(item.code)">
            {{ item.name }}
        </div>
    </div>
  </template>
  
  <script>

  export default {
    props: {
        list:{
            type:Array,
            default:()=>{}
        },
    },
    data() {
      return {
        currentTab:"0"
      };
    },
    components: {},
    methods: {
        dealTabs(id){
            this.currentTab = id;
            this.$emit("upTabs",id)
        }
       
    }
  };
  </script>
  
  <style lang="scss" scoped>
    .tabs{
        div{
            margin-right: 50px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51,51,51,0.5);
            line-height: 25px;
            cursor: pointer;
        }
        .active{
            font-weight: 600;
            color: #333333;
        }
    }

  </style>
  